module.exports = __webpack_public_path__ + "img/1.7516f670.png";